import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { selectAuthState } from '../state/auth.selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DestroyRef, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../state';

export const userPermissionGuard: CanActivateFn = route => {
    const router = inject(Router);
    const store$ = inject(Store<AppState>);
    const destroyRef = inject(DestroyRef);
    const currentPath = route.routeConfig.path;

    store$
        .select(selectAuthState)
        .pipe(takeUntilDestroyed(destroyRef))
        .subscribe(state => {
            let supportedModules: string[] = [];

            if (state.user) {
                supportedModules = state?.user?.modules;
            }

            if (supportedModules.length) {
                const isAllowed =
                    supportedModules.includes(currentPath) ||
                    (currentPath === 'ontology' && supportedModules.includes('ontology'));

                if (!isAllowed) {
                    router.navigate(['/not-found']);
                }
            }
        });
    return of(true);
};
